




























import Vue from 'vue'
import AccountBalanceDetailsEl from '@/components/elements/accountBalanceDetails/AccountBalanceDetailsEl.vue'
import Utils from '@/helpers/Utils'
import { AccountBalanceDetailsLandlineElInterface, BalanceDetailsLandlineTab, LandlineBar } from '@/config/interfaces'

export default Vue.extend({
  name: 'AccountBalanceDetailsLandlineEl',

  components: { AccountBalanceDetailsEl },

  data: () => ({
    selectedTab: 0
  }),

  methods: {
    tabChanged (idx: number) {
      this.selectedTab = idx
    },
    getBarLength (bar: LandlineBar): string {
      const width = Utils.round(
        (bar.val / bar.maxVal) * 100,
        2
      )
      return `width: ${width}%;background-color: ${bar.color};`
    }
  },

  computed: {
    getBars (): Array<LandlineBar | undefined> {
      const barTab = this.$props.templateItemData.tabs[this.selectedTab] as BalanceDetailsLandlineTab
      return [barTab?.bar1, barTab?.bar2]
    }
  },

  props: {
    templateItemData: {
      type: Object as () => AccountBalanceDetailsLandlineElInterface,
      required: true
    }
  }
})
